























import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import SignInPhoneStep from '@/components/modules/Auth/Forms/SignInPhoneStep.vue';
import SignInPhoneConfirmStep from '@/components/modules/Auth/Forms/SignInPhoneConfirmStep.vue';
import SignInNameStep from '@/components/modules/Auth/Forms/SignInNameStep.vue';
import SignInEmailConfirmStep from '@/components/modules/Auth/Forms/SignInEmailConfirmStep.vue';
import SignInProblemStep from '@/components/modules/Auth/Forms/SignInProblemStep.vue';

const Components = {
  SignInPhoneStep,
  SignInPhoneConfirmStep,
  SignInNameStep,
  SignInEmailConfirmStep,
  SignInProblemStep,
};

interface Data {
  phone: string;
  renewTimeout: number;
  activeStep: string;
  token: string;
  phoneCall: string;  
  componentKeys: string[];
  timeToOpenPage: number;
}

interface Methods {
  analyticsSend: () => void;
  onPhoneConfirmRequestSend : (phone: string, phoneCall: string, token: string) => void
  onRepeatPhoneConfirmRequestSend : (phone: string, phoneCall: string, token: string) => void
  onNextStep: () => void;
}

interface Computed {
  stepComponent: string;
}

interface Props {}

export default Vue.extend({
  name: 'SingIn',
  components: Components,
  data() {
    return {
      phone: '',
      token: '',
      phoneCall: '',
      renewTimeout: 120, // @todo get from backend
      activeStep: 'SignInPhoneStep',
      componentKeys: Object.keys(Components),
      timeToOpenPage: new Date().getTime(),
    } as Data;
  },
  created() {
    window.addEventListener('beforeunload', this.analyticsSend);
  },
  beforeDestroy() {
    this.analyticsSend();
    window.removeEventListener('beforeunload', this.analyticsSend);
  },
  methods: {
    analyticsSend() {
      this.$analytics.logEvent('registration', {
        screen: 'registration',
        time: Math.round((new Date().getTime() - this.timeToOpenPage) / 1000),
      });
    },
    onPhoneConfirmRequestSend (phone: string, phoneCall: string, token: string) {
      this.phone = phone;
      this.phoneCall = phoneCall;
      this.token = token;
      this.onNextStep()
    },	
    onRepeatPhoneConfirmRequestSend (phone: string, phoneCall: string, token: string) {
      this.phone = phone;
      this.phoneCall = phoneCall;
      this.token = token;
    },		
    onNextStep() {
      this.activeStep = this.componentKeys[this.componentKeys.indexOf(this.activeStep) + 1];
    },
    onProblemStep() {
      this.activeStep = 'SignInProblemStep';
    },
    onEmailConfirmStep() {
      this.activeStep = 'SignInEmailConfirmStep';
    },
    onSignUpStep() {
      this.activeStep = 'SignInNameStep';
    },
    onGoToMain() {
      this.$router.push('/');
    },
    onPreviousStep() {
      if (this.activeStep === this.componentKeys[0]) {
        return;
      }
      this.activeStep = this.componentKeys[this.componentKeys.indexOf(this.activeStep) - 1];
    },
    onFirstStep() {
      this.activeStep = 'SignInPhoneStep';
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
